import { jsx as _jsx } from "react/jsx-runtime";
import { IconButtonContainerStyled, IconButtonStickyContainerStyled } from '../pdfViewer.styled';
import { IconButton } from './../../iconButton/iconButton';
export const ScrollDownButton = (props) => {
    return props.scrollDownButton &&
        !props.scrollAtBottom &&
        props.pagesTextContentLength > 0 &&
        props.styles &&
        props.styles.iconButton ? (_jsx(IconButtonStickyContainerStyled, { children: _jsx(IconButtonContainerStyled, { styles: props.styles, children: _jsx(IconButton, { ...props.scrollDownButton, icon: {
                    ...props.scrollDownButton?.icon,
                    onClick: props.onScrollToBottom,
                }, size: props.styles?.iconButton.size, variant: props.styles?.iconButton.variant }) }) })) : null;
};
//# sourceMappingURL=scrollDownButton.js.map